import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { useProductsContext } from "../context/Context";
import NavbarItem from "../data";
import SocialItem from "./Social_item";

const Logo = "https://i.ibb.co/MMg1kXh/maruf-img-3.jpg";

const Sidebar = () => {
  const { isSidebarOpen, openSidebar, CursorBig, CursorSmall } =
    useProductsContext();

  return (
    <SidebarStyled>
      <div className={`${isSidebarOpen ? "sidebar show-sidebar" : "sidebar"}`}>
        <div className="row sidebar__container">
          <div className="sidebar__logo">
            <Link to="/">
              <img src={Logo} alt="logo" />
            </Link>
          </div>
          <div className="sidebar__content">
            <ul className="sidebar__list">
              {NavbarItem.map(({ id, url, text }) => {
                return (
                  <li className="sidebar__item" key={id}>
                    <Link
                      className="sidebar__link"
                      onClick={openSidebar}
                      to={url}
                      onMouseOver={CursorBig}
                      onMouseOut={CursorSmall}
                    >
                      {text}
                    </Link>
                  </li>
                );
              })}
            </ul>
            <div className="contact">
              <a href="mailto:mmaruf1137@gmail.com" className="contact__email">
                mmaruf1137@gmail.com
              </a>
              <a href="tel:01764469753" className="contact__number">
                01764469753
              </a>
              <p className="p-text contact__address">
                new ailpara, narayanganj, dhaka, bangladesh
              </p>
              <SocialItem />
            </div>
          </div>
        </div>
      </div>
    </SidebarStyled>
  );
};

export default Sidebar;

const SidebarStyled = styled.div`
  .sidebar {
  }
`;
